const ALGORITHM_PKCS = 'RSA/NONE/PKCS1Padding';

const encrypt = (publicKey, algorithm) => {
  /**
   * Currently the encryption PKCS is used by FD and THDigital.
   * If the algorithm is undefined or equals to ${algorithmType.PKCS}
   * the current solution will be used, otherwise the new encryption
   * will be defined as the encryption function.
   */
  if (!algorithm || algorithm === ALGORITHM_PKCS) {
    return import('node-rsa').then(({ default: NodeRSA }) => {
      const key = new NodeRSA(`-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`);
      key.setOptions({ encryptionScheme: 'pkcs1' });
      return field => key.encrypt(field, 'base64');
    });
  }

  // New encrypt key generator
  return import('node-forge').then(({ default: NodeForge }) => {
    const pem = `-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`;
    const forgePublicKey = NodeForge.pki.publicKeyFromPem(pem);
    return field => {
      const encryptedValue = NodeForge.util.encode64(
        forgePublicKey.encrypt(field, 'RSA-OAEP', {
          md: NodeForge.md.sha512.create(),
        })
      );
      return 'ENC_[' + encryptedValue + ']';
    };
  });
};

export const encryptCredit = ({
  credit,
  fdPublicKey,
  isUsingTokenEx = false,
  algorithm = undefined,
}) =>
  encrypt(fdPublicKey, algorithm).then(encryptWithKey => {
    return {
      ...credit,
      cardNumber: encryptWithKey(credit.cardNumber),
      expiryDate: {
        month: isUsingTokenEx ? credit.expiryDate.month : encryptWithKey(credit.expiryDate.month),
        year: isUsingTokenEx ? credit.expiryDate.year : encryptWithKey(credit.expiryDate.year),
      },
      securityCode: encryptWithKey(credit.securityCode),
    };
  });

export { getStoredPrepaidCard, storePrepaidCard } from './store-prepaid-card';
